// OrderConfirmation.jsx - Updated without WhatsApp detection
import React from 'react';
import { Button } from '../components/ui/Button';
import './OrderConfirmation.css';
import { Link } from 'react-router-dom';

const OrderConfirmation = ({ 
  isOpen, 
  onClose, 
  orderDetails, 
  handleReturnToShop,
  sendToWhatsApp,
  emailSent
}) => {
  if (!isOpen || !orderDetails) return null;

  // Format date to be more readable
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="confirmation-overlay">
      <div className="confirmation-modal">
        <div className="confirmation-header">
          <h2>Thank You For Your Order!</h2>
          <button className="close-confirmation-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="confirmation-content">
          <div className="order-success-animation">
            <div className="checkmark-circle">
              <div className="checkmark"></div>
            </div>
          </div>
          
          <div className="order-details">
            <h3>Order Details</h3>
            <div className="order-info-grid">
              <div className="order-info-item">
                <span className="info-label">Order Number:</span>
                <span className="info-value">{orderDetails.displayOrderId}</span>
              </div>
              <div className="order-info-item">
                <span className="info-label">Date:</span>
                <span className="info-value">{formatDate(orderDetails.date)}</span>
              </div>
              <div className="order-info-item">
                <span className="info-label">Total:</span>
                <span className="info-value highlight">R{orderDetails.totalAmount.toFixed(2)}</span>
              </div>
              <div className="order-info-item">
                <span className="info-label">Status:</span>
                <span className="info-value status-badge">Pending Payment</span>
              </div>
            </div>
          </div>
          
          <div className="payment-info">
            <h3>Payment Information</h3>
            <div className="payment-methods">
              <div className="payment-method">
                <h4>Bank Transfer</h4>
                <div className="bank-details">
                  <p><strong>Account Name:</strong> Two Gs Crafting</p>
                  <p><strong>Bank:</strong> CAPITEC</p>
                  <p><strong>Account Number:</strong> 1827947363</p>
                  <p><strong>Branch Code:</strong> 470010</p>
                  <p><strong>Reference:</strong> {orderDetails.displayOrderId}</p>
                </div>
              </div>
            </div>
            <div className="payment-note">
              <p>Please use your order number as the payment reference</p>
              <p>Your order will be processed once payment is confirmed</p>
            </div>
          </div>
          
          {/* Email confirmation section */}
          {emailSent && (
            <div className="notification-status">
              <h3>Order Communication</h3>
              <div className="notification-details">
                <div className="notification-item">
                  <div className="notification-icon email-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20">
                      <path fill="currentColor" d="M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,8l-8,5L4,8V6l8,5l8-5V8z"/>
                    </svg>
                  </div>
                  <div className="notification-text">
                    <p>An order confirmation has been sent to your email address.</p>
                    <p className="notification-subtext">Please check your inbox (and spam folder) for details.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <div className="next-steps">
            <h3>What's Next?</h3>
            <ul className="steps-list">
              <li>
                <div className="step-icon">1</div>
                <div className="step-text">Complete your payment using the details above</div>
              </li>
              <li>
                <div className="step-icon">2</div>
                <div className="step-text">Notify us of your payment via WhatsApp or by email</div>
              </li>
              <li>
                <div className="step-icon">3</div>
                <div className="step-text">We'll confirm your payment and begin processing your order</div>
              </li>
              <li>
                <div className="step-icon">4</div>
                <div className="step-text">We'll contact you when your order is ready!</div>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="confirmation-actions">
          <Button 
            className="whatsapp-btn" 
            onClick={sendToWhatsApp}
          >
            <span className="whatsapp-icon">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.72.045.419-.1.824z"/>
              </svg>
            </span>
            Send Order Details to WhatsApp
          </Button>
          <Button className="continue-btn" onClick={handleReturnToShop}>
            Continue Shopping
          </Button>
        </div>
        
        <div className="order-saved-note">
          <p>Your order has been saved and a copy has been sent to our team.</p>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;